/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { ActionIcon, Indicator, Popover, PopoverProps, Text, Tooltip, useMantineTheme } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconBellRinging } from '@tabler/icons';
import { useContext } from 'react';
import { WindowContext } from '../../Service/Context/WindowContext';
import { NotificationsContext } from '../../Service/Context/NotificationsContext';
import BookitupNotifications from './GeneralBookitupNotifications';

const phoneConfig: Partial<PopoverProps> = {
  position: 'bottom-end',
  transition: 'slide-down',
  offset: 10,
  arrowOffset: 15,
};

const desktopConfig: Partial<PopoverProps> = {
  position: 'right-start',
  offset: 15,
  transition: 'slide-right',
};

const NotificationNavIcon = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const { xs, sm, windowWidth, windowHeight } = useContext(WindowContext);
  const { markAsSeen, unseenCount } = useContext(NotificationsContext);
  const opts = sm ? phoneConfig : desktopConfig;
  const popoverWidth = xs ? windowWidth - 10 : 450;
  const popoverHeight = xs ? windowHeight - 130 : 600;

  const { colorScheme, colors } = useMantineTheme();
  const darkMode = colorScheme === 'dark';

  const onClose = () => {
    close();
    markAsSeen();
  };

  return (
    <Popover withArrow radius="md" opened={opened} onClose={onClose} width={popoverWidth} {...opts}>
      <Popover.Target>
        <div>
          <Tooltip disabled={opened} label="Benachrichtigungen" position="right" withArrow transition="slide-right">
            <Indicator
              inline
              disabled={unseenCount < 1}
              radius="xl"
              offset={7}
              size={20}
              color="red"
              label={
                <Text color="white" size={10}>
                  {unseenCount}
                </Text>
              }
            >
              <ActionIcon
                sx={(theme) => ({
                  color:
                    theme.colorScheme === 'dark'
                      ? opened
                        ? theme.colors.blue[1]
                        : '#E5E5E5'
                      : opened
                      ? theme.colors.blue[4]
                      : '#1A1A1A',
                  backgroundColor: 'transparent',
                  width: 40,
                  height: 40,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: 10,
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
                  },
                })}
              >
                {' '}
                <IconBellRinging size={24} onClick={() => (opened ? close() : open())} />
              </ActionIcon>
            </Indicator>
          </Tooltip>
        </div>
      </Popover.Target>
      <Popover.Dropdown
        id="scrollableDiv"
        sx={{
          height: popoverHeight,
          overflow: 'auto',
          scrollbarWidth: 'thin',
          boxShadow: '0px 0px 8px #00000039',
          borderRadius: 10,
          zIndex: 101,
        }}
      >
        <BookitupNotifications />
      </Popover.Dropdown>
    </Popover>
  );
};

export default NotificationNavIcon;
